import type { ShopSummary, SyncFreshness } from '../../api/types.ts';

export interface HealthMeta {
  label: string;
  color: 'success' | 'warning' | 'error' | 'default';
}

function localDateKey(now: Date): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function licenceHealth(expiry: string | null, now = new Date()): HealthMeta {
  if (expiry === null) return { label: 'No licence', color: 'default' };
  if (expiry < localDateKey(now)) return { label: 'Expired', color: 'error' };
  return { label: `Valid to ${expiry}`, color: 'success' };
}

export function enrollmentHealth(shop: ShopSummary): HealthMeta {
  if (shop.key_registered_at !== null) return { label: 'Registered', color: 'success' };
  if (shop.outstanding_code_expires_at !== null) return { label: 'Registration code issued', color: 'warning' };
  return { label: 'Not registered', color: 'default' };
}

export function resolvedSyncFreshness(shop: ShopSummary): SyncFreshness {
  if (shop.sync_freshness !== undefined) return shop.sync_freshness;
  return shop.last_sync_at === null ? 'never' : 'fresh';
}

export function formatClockSkew(skewMs: number | null): string {
  if (skewMs === null) return '-';
  if (skewMs === 0) return 'No difference';
  const absoluteSeconds = Math.round(Math.abs(skewMs) / 1000);
  const minutes = Math.floor(absoluteSeconds / 60);
  const seconds = absoluteSeconds % 60;
  let duration: string;
  if (minutes > 0 && seconds > 0) {
    duration = `${minutes}m ${seconds}s`;
  } else if (minutes > 0) {
    duration = `${minutes}m`;
  } else {
    duration = `${seconds}s`;
  }
  const direction = skewMs > 0 ? 'behind' : 'ahead';
  return `${duration} ${direction}`;
}
